import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './localization/en.json';

const languageForRegions = {
  sg: ['en']
}

const LanguageMap = {
  en
}

function getResources() {
  const resources = {};
  Object.keys(languageForRegions).map(country => {
    languageForRegions[country].forEach(language => {
      resources[language] = {
        translation: LanguageMap[language]
      }
    })
  })
  return resources;
}

function getLng() {
  return languageForRegions.sg[0];
}

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // special options for react-i18next
    // learn more: https://react.i18next.com/components/i18next-instance
    react: {
      wait: true,
    },
    lng: getLng(),
    resources: getResources()
  });

export default i18n;
